<div [formGroup]="elementForm">
    <div class="input-group">
        <span class="input-group-addon" *ngIf="!isShowProtectedList && (isEmailType || isPasswordType)">
            <img
                class="element-icon"
                src="./assets/img/websites/forms-icons/lpc-f-{{ type.value }}-icon.svg"
                alt="{{ type.value }} icon"
            />
        </span>
        <div
            *ngIf="isShowProtectedList || isShowDropdown"
            class="input-group-btn elements-dropdown"
            [class.disabled]="isFormControlDisabled"
            dropdown
            container="body"
        >
            <button class="btn btn-default type-dropdown-toggle" type="button" dropdownToggle>
                <img
                    class="element-icon"
                    src="./assets/img/websites/forms-icons/lpc-f-{{ type.value }}-icon.svg"
                    alt="{{ type.value }} icon"
                />
                <span class="caret"></span>
            </button>
            <ul class="dropdown-menu custom-left-position" *dropdownMenu>
                <ng-container *ngIf="isShowDefaultList; else protectedList">
                    <ng-container *ngFor="let controlType of defaultElements.keys()">
                        <li
                            *ngIf="
                                controlType === formInputType.email
                                    ? !isHasEmail
                                    : controlType === formInputType.phone
                                      ? !isHasPhone
                                      : controlType === formInputType.file
                                        ? !isHasFile
                                        : true
                            "
                            (click)="changeElementType(controlType)"
                        >
                            <a>
                                <img
                                    class="element-icon"
                                    src="./assets/img/websites/forms-icons/lpc-f-{{ controlType }}-icon.svg"
                                    alt="{{ controlType }} icon"
                                />
                                {{ controlsLabels[controlType] | translate }}
                            </a>
                        </li>
                    </ng-container>
                </ng-container>
                <ng-template #protectedList>
                    <ng-container *ngFor="let controlType of defaultProtectedElements.keys()">
                        <li
                            [class.disabled]="
                                controlType === formInputType.email
                                    ? !isHasEmail
                                    : controlType === formInputType.phone
                                      ? !isHasPhone
                                      : controlType === formInputType.file
                                        ? !isHasFile
                                        : false
                            "
                            (click)="changeElementType(controlType)"
                        >
                            <a>
                                <img
                                    class="element-icon"
                                    src="./assets/img/websites/forms-icons/lpc-f-{{ controlType }}-icon.svg"
                                    alt="{{ controlType }} icon"
                                />
                                {{ controlsLabels[controlType] | translate }}
                            </a>
                        </li>
                    </ng-container>
                </ng-template>
            </ul>
        </div>

        <input
            *ngIf="type.value !== formControlType.checkbox"
            type="text"
            class="form-control"
            [class.disabled]="type.value === formInputType.hidden"
            [formControl]="label"
        />
        <input
            *ngIf="type.value === formControlType.checkbox"
            type="text"
            class="form-control disabled"
            [value]="'control_checkbox' | translate"
        />
    </div>
    <div class="mb-20" *ngIf="type.value === formControlType.checkbox">
        <sp-common-editor
            class="sp-editor form-control checkbox-textarea"
            [toolbarMenu]="'bold italic link'"
            [content]="label.value.toString()"
            [baseHref]="baseHref"
            [deviceMode]="deviceMode"
            (changeContent)="saveLabel($event)"
        >
        </sp-common-editor>
    </div>

    <div
        *ngIf="
            (typeGuards.isInput(elementFormValue) || typeGuards.isTextarea(elementFormValue)) &&
            type.value !== formInputType.hidden &&
            !isPasswordType
        "
        class="form-group mb-20"
    >
        <input
            *ngIf="!typeGuards.isInputDate(elementFormValue)"
            class="form-control"
            type="text"
            [class.disabled]="isDynamicPlaceholderEnabled.value"
            [placeholder]="'control_input_placeholder' | translate"
            [formControl]="placeholder"
        />

        <span
            class="help-block small"
            *ngIf="typeGuards.isSystemElement(elementFormValue) && !isPasswordType && elementFormValue.type !== 'file'"
        >
            {{ "system_variable_help" | translate }}
            <a class="dotted" [tooltip]="varNameTooltip" placement="bottom" triggers="mouseover:mouseleave">
                {{ variable.value }}
            </a>
            <ng-template #varNameTooltip>
                {{ "system_variable" | translate }} <span class="system-variable-label">{{ variable.value }}</span>
            </ng-template>
        </span>

        <span class="help-block small" *ngIf="elementFormValue.type === 'file'">
            {{ "control_file_crm_deal" | translate }}
        </span>
    </div>

    <div class="form-horizontal form-row mb-20" *ngIf="type.value === formInputType.phone">
        <div class="form-group">
            <label class="control-label col-xs-9">
                {{ "form_use_dynamic_mask" | translate }}
                <span
                    class="small sp-icon icon-question color-light hover-effect"
                    [tooltip]="'form_use_dynamic_mask_tooltip' | translate"
                    [placement]="'top'"
                    [adaptivePosition]="true"
                    triggers="mouseover:mouseleave"
                ></span>
            </label>
            <div class="col-xs-3 text-right">
                <sp-switch
                    [active]="isDynamicPlaceholderEnabled.value"
                    (toggleActiveEvent)="setDynamicPhonePlaceholder($event)"
                ></sp-switch>
            </div>
        </div>
    </div>

    <div *ngIf="typeGuards.isInput(elementFormValue) && type.value === formInputType.hidden" class="form-group mb-20">
        <span class="help-block small">
            {{ "hidden_input_help" | translate }}
        </span>

        <div [class.has-error]="value.hasError('required')">
            <label class="control-label">
                {{ "hidden_input_value" | translate }}
            </label>
            <input
                class="form-control"
                type="text"
                [placeholder]="'input_value' | translate"
                [formControl]="value"
                [maxlength]="255"
            />
            <span *ngIf="value.hasError('required')" class="help-block small">
                {{ "control_errors_required" | translate }}
            </span>
        </div>
    </div>

    <div *ngIf="typeGuards.isTextarea(elementFormValue) && !isPaymentEduForm" class="form-group mb-20">
        <label class="control-label">
            {{ "crm_data_label" | translate }}
        </label>

        <select class="form-control" [formControl]="crmCommentPlace">
            <option *ngFor="let option of crmCommentPlaceArray" [ngValue]="option">
                {{ option + "_option" | translate }}
            </option>
        </select>
    </div>

    <div *ngIf="!typeGuards.isSystemElement(elementFormValue) && !isAddressBookListDisabled" class="form-group mb-20">
        <label class="control-label">
            {{ "crm_mailing_list_variable" | translate }}
        </label>

        <select class="form-control" [class.disabled]="!addressBookVariablesList?.length" [formControl]="variable">
            <option [ngValue]="null" disabled>
                {{
                    (addressBookVariablesList?.length ? "control_choose_variable" : "error_select_address_book")
                        | translate
                }}
            </option>
            <option *ngIf="variable.value" [ngValue]="variable.value">
                {{ variable.value }}
            </option>
            <option
                *ngFor="let ab_var of filteredAddressBookVariables"
                [ngValue]="ab_var.variable_name"
                [disabled]="disableAddressBookVariable(ab_var)"
            >
                {{ ab_var.variable_name }}
            </option>
        </select>

        <div *ngIf="typeGuards.isTextarea(elementFormValue)" class="help-block small text-muted">
            {{ "textarea_in_mailing_list_variable_hint" | translate }}
        </div>
    </div>

    <div *ngIf="typeGuards.isTextarea(elementFormValue) && isPaymentEduForm" class="form-group">
        <div class="alert alert-sm alert-info-mutted">
            {{ "crm_contact_notes_message" | translate }}
        </div>
    </div>

    <div
        *ngIf="!typeGuards.isSystemElement(elementFormValue) && crmContactsVariablesList?.length"
        class="form-group mb-20"
        [class.has-error]="crmContactVariable.hasError('atLeastOne')"
        [class.disabled]="isCrmContactListDisabled"
    >
        <label class="control-label">
            {{ "crm_contact_variable" | translate }}
        </label>

        <select
            class="form-control"
            [class.disabled]="!crmContactsVariablesList?.length || isCrmDealVariableSelect"
            [formControl]="crmContactVariable"
            (change)="changeCrmContactVariable()"
        >
            <option [ngValue]="null" disabled>
                {{ "control_choose_variable" | translate }}
            </option>
            <option *ngIf="crmContactVariable.value" [ngValue]="crmContactVariable.value">
                {{ getVariableName(crmContactVariable.value, variableTypes.crmContactAttribute) | translate }}
            </option>
            <option
                *ngFor="let field of filteredContactFields"
                [ngValue]="field"
                [disabled]="disableFilteredContactFields"
            >
                {{ field | translate }}
            </option>
            <option
                *ngFor="let variable of filteredCrmContactsVariables"
                [ngValue]="variable.id"
                [disabled]="disableCrmSelectVariable(variable)"
            >
                {{ variable.name | translate }}
            </option>
        </select>
        <span *ngIf="crmContactVariable.hasError('atLeastOne')" class="help-block small">
            {{ "error_crm_contact_or_deal_required" | translate }}
        </span>
    </div>

    <div
        *ngIf="
            !typeGuards.isSystemElement(elementFormValue) && crmDealsVariablesList?.length && !isCrmDealsListDisabled
        "
        class="form-group mb-20"
        [class.has-error]="crmDealVariable.hasError('atLeastOne')"
    >
        <label class="control-label">
            {{ "crm_deal_variable" | translate }}
        </label>

        <select
            class="form-control"
            [class.disabled]="!crmDealsVariablesList?.length || isCrmContactVariableSelect"
            [formControl]="crmDealVariable"
            (change)="changeCrmDealVariable()"
        >
            <option [ngValue]="null">
                {{ (crmDealsVariablesList?.length ? "crm_choose_deal_variable" : "crm_choose_pipeline") | translate }}
            </option>
            <option *ngIf="crmDealVariable.value" [ngValue]="crmDealVariable.value">
                {{ getVariableName(crmDealVariable.value, variableTypes.crmDealAttribute) | translate }}
            </option>
            <option
                *ngFor="let variable of filteredCrmDealsVariables"
                [ngValue]="variable.id"
                [disabled]="disableCrmSelectVariable(variable)"
            >
                {{ variable.name | translate }}
            </option>
        </select>
        <span *ngIf="crmDealVariable.hasError('atLeastOne')" class="help-block small">
            {{ "error_crm_contact_or_deal_required" | translate }}
        </span>
    </div>

    @if (addChatBotToForm && isInitVariables) {
        @for (control of selectedVariablesForm.controls; let i = $index; track i) {
            @let chatBot = selectedChatBots.at(i).value;

            <div class="mb-20">
                <div class="form-group">
                    <label class="control-label">
                        {{ "field_in_chat_bot" | translate }} <span>{{ chatBot.botName }}</span>
                    </label>
                    <select
                        class="form-control"
                        [formControl]="control"
                        [compareWith]="compareVariables"
                        (change)="changeBotVariable(chatBot, control.value)"
                    >
                        <option disabled [ngValue]="null">{{ "choose_bot_variable" | translate }}</option>
                        @for (
                            variable of filteredBotVariables(chatBot.socialNetwork, variablesOptions[i]);
                            let j = $index;
                            track j
                        ) {
                            <option [ngValue]="variable">
                                {{ variable?.name }}
                            </option>
                        }
                    </select>
                </div>
            </div>
        }
    }

    <div *ngIf="typeGuards.isRadio(elementFormValue)" class="form-group mb-20 options-list" formArrayName="options">
        <ng-container *ngIf="isCrmDealVariableSelect || isCrmContactVariableSelect; else displayDefaultRadio">
            <ng-container *ngFor="let option of options.controls; index as optionsIndex">
                <div class="well well-sm mb-10">
                    <div class="form-group radio-element" [formGroupName]="optionsIndex">
                        <div>
                            <div class="input-group">
                                <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                <input type="text" class="form-control disabled" formControlName="label" />
                            </div>
                        </div>
                        <div class="radio-btn-container">
                            <input
                                class="non-editable-check-radio-control"
                                type="radio"
                                placement="bottom"
                                triggers="mouseover:mouseleave"
                                [checked]="option.value.selected"
                                [tooltip]="defaultOptionTooltip"
                                (click)="checkRadioOption(options, optionsIndex)"
                            />
                        </div>

                        <ng-template #defaultOptionTooltip>
                            <span *ngIf="!option.value.selected">{{ "default_options_tooltip_1" | translate }}</span>
                            <span *ngIf="option.value.selected">{{ "default_options_tooltip_2" | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #displayDefaultRadio>
            <ng-container *ngFor="let option of options.controls; index as optionsIndex">
                <div class="well well-sm mb-10">
                    <div class="form-group radio-element" [formGroupName]="optionsIndex">
                        <div>
                            <div class="input-group">
                                <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                <input type="text" class="form-control" formControlName="label" />
                            </div>
                            <div class="input-group">
                                <span class="input-group-addon">{{ "form_radio_value" | translate }}</span>
                                <input type="text" class="form-control" formControlName="value" />
                            </div>
                        </div>
                        <button
                            class="btn btn-link"
                            [class.disabled]="options.length === 2"
                            (click)="removeRadioOption(options, optionsIndex, $event)"
                        >
                            <img src="./assets/img/websites/lpc-delete-icon.svg" alt="delete icon" />
                        </button>

                        <input
                            class="default-check-radio-control"
                            type="radio"
                            placement="bottom"
                            triggers="mouseover:mouseleave"
                            [checked]="option.value.selected"
                            [tooltip]="defaultOptionTooltip"
                            (click)="checkRadioOption(options, optionsIndex)"
                        />

                        <ng-template #defaultOptionTooltip>
                            <span *ngIf="!option.value.selected">{{ "default_options_tooltip_1" | translate }}</span>
                            <span *ngIf="option.value.selected">{{ "default_options_tooltip_2" | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </ng-container>

            <a class="dotted" (click)="addRadioOption(options)">{{ "add" | translate }}</a>
        </ng-template>
    </div>

    <div *ngIf="typeGuards.isSelect(elementFormValue)" class="form-group mb-20 options-list" formArrayName="options">
        <ng-container *ngIf="isCrmDealVariableSelect || isCrmContactVariableSelect; else displayDefaultSelect">
            <ng-container *ngFor="let option of options.controls; index as optionsIndex">
                <div class="well well-sm mb-10">
                    <div class="form-group radio-element" [formGroupName]="optionsIndex">
                        <div>
                            <div class="input-group">
                                <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                <input type="text" class="form-control disabled" formControlName="label" />
                            </div>
                        </div>
                        <div class="radio-btn-container" *ngIf="!option.value.selected">
                            <input
                                class="non-editable-check-radio-control"
                                type="radio"
                                placement="bottom"
                                triggers="mouseover:mouseleave"
                                [checked]="option.value.selected"
                                [tooltip]="defaultOptionTooltip"
                                (click)="checkSelectOption(options, optionsIndex)"
                            />
                            <ng-template #defaultOptionTooltip>
                                <span *ngIf="!option.value.selected">{{
                                    "default_options_tooltip_1" | translate
                                }}</span>
                                <span *ngIf="option.value.selected">{{ "default_options_tooltip_2" | translate }}</span>
                            </ng-template>
                        </div>

                        <div class="radio-btn-container" *ngIf="option.value.selected">
                            <input
                                class="non-editable-check-radio-control"
                                type="radio"
                                [checked]="option.value.selected"
                                (click)="checkSelectOption(options, optionsIndex)"
                            />
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #displayDefaultSelect>
            <ng-container *ngFor="let option of options.controls; index as optionsIndex">
                <div class="well well-sm mb-10">
                    <div class="form-group radio-element" [formGroupName]="optionsIndex">
                        <div>
                            <div class="input-group">
                                <span class="input-group-addon">{{ "control_text" | translate }}</span>
                                <input type="text" [maxlength]="255" class="form-control" formControlName="label" />
                            </div>
                            <div class="input-group">
                                <span class="input-group-addon">{{ "form_radio_value" | translate }}</span>
                                <input type="text" class="form-control" formControlName="value" />
                            </div>
                        </div>
                        <button
                            class="btn btn-link"
                            [class.disabled]="options.length === 2"
                            (click)="removeSelectOption(options, optionsIndex, $event)"
                        >
                            <img src="./assets/img/websites/lpc-delete-icon.svg" alt="delete icon" />
                        </button>

                        <div *ngIf="!option.value.selected">
                            <input
                                class="default-check-radio-control"
                                type="radio"
                                placement="bottom"
                                triggers="mouseover:mouseleave"
                                [checked]="option.value.selected"
                                [tooltip]="defaultOptionTooltip"
                                (click)="checkSelectOption(options, optionsIndex)"
                            />
                            <ng-template #defaultOptionTooltip>
                                <span *ngIf="!option.value.selected">{{
                                    "default_options_tooltip_1" | translate
                                }}</span>
                                <span *ngIf="option.value.selected">{{ "default_options_tooltip_2" | translate }}</span>
                            </ng-template>
                        </div>

                        <div *ngIf="option.value.selected">
                            <input
                                class="default-check-radio-control"
                                type="radio"
                                [checked]="option.value.selected"
                                (click)="checkSelectOption(options, optionsIndex)"
                            />
                        </div>
                    </div>
                </div>
            </ng-container>

            <a class="dotted" (click)="addSelectOption(options)">
                {{ "add" | translate }}
            </a>
        </ng-template>
    </div>

    <div class="form-horizontal form-row">
        <div *ngIf="showMakeRequiredPredicate" class="form-group">
            <label class="col-xs-9 control-label">
                {{ "control_required" | translate }}
            </label>
            <div class="col-xs-3 text-right">
                <sp-switch [active]="required.value" (toggleActiveEvent)="toggleRequired($event)"></sp-switch>
            </div>
        </div>
    </div>
</div>
